export interface IStatelessFormService {}

export class StatelessFormService implements IStatelessFormService {}